// Shared list-page utilities for Businesses/Events/Communities
import { Loader2, Search } from 'lucide-react';

export function PageHeader({ title, subtitle, testId }) {
  return (
    <div className="mb-6" data-testid={testId}>
      <h1 className="text-3xl md:text-4xl font-serif font-bold text-[#2B2D42]" style={{ fontFamily: 'Playfair Display, serif' }}>
        {title}
      </h1>
      {subtitle && <p className="text-sm text-[#6D6875] mt-1">{subtitle}</p>}
    </div>
  );
}

export function SearchBar({ value, onChange, placeholder, testId }) {
  return (
    <div className="flex items-center bg-white border border-[#F4F1DE] rounded-full px-4 py-2.5 mb-4 focus-within:border-[#E07A5F]">
      <Search className="w-4 h-4 text-[#B5B5B5] mr-2" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        data-testid={testId}
        className="flex-1 bg-transparent outline-none text-sm text-[#2B2D42] placeholder-[#B5B5B5]"
      />
    </div>
  );
}

export function FilterChips({ items, value, onChange, testIdPrefix }) {
  return (
    <div className="flex gap-2 overflow-x-auto pb-2 mb-4 -mx-4 px-4 sm:mx-0 sm:px-0">
      <button
        onClick={() => onChange('')}
        data-testid={`${testIdPrefix}-all`}
        className={`flex-shrink-0 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide transition-colors ${
          !value ? 'bg-[#C8553D] text-white' : 'bg-white border border-[#F4F1DE] text-[#6D6875]'
        }`}
      >
        All
      </button>
      {items.map((item) => (
        <button
          key={item}
          onClick={() => onChange(item)}
          data-testid={`${testIdPrefix}-${item.toLowerCase().replace(/[^a-z]+/g, '-')}`}
          className={`flex-shrink-0 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide transition-colors ${
            value === item ? 'bg-[#C8553D] text-white' : 'bg-white border border-[#F4F1DE] text-[#6D6875] hover:border-[#E07A5F]'
          }`}
        >
          {item}
        </button>
      ))}
    </div>
  );
}

export function LoaderBlock({ testId = 'loader' }) {
  return (
    <div className="flex items-center justify-center py-16" data-testid={testId}>
      <Loader2 className="w-8 h-8 animate-spin text-[#C8553D]" />
    </div>
  );
}

export function EmptyState({ icon: Icon, title, sub, action, testId }) {
  return (
    <div className="flex flex-col items-center text-center py-16 bg-white rounded-2xl border border-[#F4F1DE]" data-testid={testId}>
      {Icon && <Icon className="w-12 h-12 text-[#FFE5DD] mb-3" />}
      <h3 className="text-lg font-bold text-[#2B2D42]">{title}</h3>
      {sub && <p className="text-sm text-[#6D6875] mt-1 max-w-md">{sub}</p>}
      {action}
    </div>
  );
}
